import { themeUrl } from '@/utils/urls';
import axios from 'axios';

const DEFAULT_THEME = 'pixery';

export default function loadTheme(store) {
  store.watch(
    state => state.project.project && state.project.project.settings.theme,
    theme => theme && theme !== DEFAULT_THEME && load(theme),
  );

  // ////////////////////////
  function load(name) {
    console.info(`Loading theme %c ${name} `, 'background: orange');

    const link = document.createElement('link');

    Object.assign(link, {
      href: themeUrl(`/theme/${name}/theme.css`),
      rel: 'stylesheet',
    });

    document.head.appendChild(link);

    axios.get(themeUrl(`/theme/${name}/theme.json`))
      .then(({ data }) => store.dispatch('service/setTheme', data));
  }
}
